import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-edsourcecode',
  templateUrl: './edsourcecode.component.html',
  styleUrls: ['./edsourcecode.component.css']
})
export class EdsourcecodeComponent implements OnInit {

  public sourcecode:any;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public dialogRef: MatDialogRef<EdsourcecodeComponent>) { 
    console.log(data);
  }

  ngOnInit() {
    if(this.data)      
      this.sourcecode=this.data;  
  }

  Onsourcecode()
  {
    console.log(this.sourcecode)
    this.dialogRef.close({sourcecode:this.sourcecode});
  }

  Close()
  {
    this.dialogRef.close();
  }

}
